import { combineReducers } from 'redux';
import LanguageSwitcher from '@iso/redux/languageSwitcher/reducer';

export default combineReducers({
  LanguageSwitcher,
});
